import { Box } from '@mui/material';

/* E5, review du 02/09 : etat de chargement en squelette, a la place du rond
 * qui tournait sur un ecran vide. Un bandeau de cartes + un bloc principal
 * qui pulsent doucement, sans dependance nouvelle. */

const Bloc = ({ h, w, flex }) => (
  <Box sx={{
    height: h,
    width: w || "auto",
    flex: flex,
    background: "#ECE7E2",
    animation: "pulseSkeleton 1.4s ease-in-out infinite",
  }} />
)

const SkeletonEcran = ({ avecTable }) => (
  <Box sx={{ marginTop: "30px" }}>
    <style>{`@keyframes pulseSkeleton { 0% { opacity: 1; } 50% { opacity: 0.45; } 100% { opacity: 1; } }`}</style>
    <Box sx={{ display: "flex", gap: "20px", marginBottom: "25px" }}>
      <Bloc h="95px" flex={1} />
      <Bloc h="95px" flex={1} />
      <Bloc h="95px" flex={1} />
      <Bloc h="95px" flex={1} />
    </Box>
    {avecTable === true ? (
      <>
        <Bloc h="46px" w="100%" />
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px" }}>
          <Bloc h="38px" w="100%" />
          <Bloc h="38px" w="100%" />
          <Bloc h="38px" w="100%" />
          <Bloc h="38px" w="100%" />
          <Bloc h="38px" w="100%" />
        </Box>
      </>
    ) : (
      <Box sx={{ display: "flex", gap: "20px" }}>
        <Bloc h="300px" flex={0.6} />
        <Box sx={{ flex: 0.4, display: "flex", flexDirection: "column", gap: "15px" }}>
          <Bloc h="92px" w="100%" />
          <Bloc h="92px" w="100%" />
          <Bloc h="92px" w="100%" />
        </Box>
      </Box>
    )}
  </Box>
)

export default SkeletonEcran
